module.exports = __webpack_public_path__ + "images/email/line-active-dc4711423267b5b9cc9175b496d257c7.png";